import { ToggleButtonGroup } from '@mui/material';
import { ToggleButton } from '@elementary/common-ui/components';
import { SpendRange } from 'shared/services/settingsApi';

const OPTIONS: Array<{ value: SpendRange; label: string }> = [
  { value: '3m', label: '3 Months' },
  { value: '6m', label: '6 Months' },
  { value: '1y', label: '1 Year' },
  { value: 'mtd', label: 'Month to Date' },
  { value: 'ytd', label: 'Year to Date' },
];

type Props = {
  value: SpendRange;
  onChange: (value: SpendRange) => void;
};

const RangeToggle = ({ value, onChange }: Props) => (
  <ToggleButtonGroup
    exclusive
    value={value}
    onChange={(_, val: SpendRange | null) => {
      if (val) {
        onChange(val);
      }
    }}
  >
    {OPTIONS.map((o) => (
      <ToggleButton key={o.value} value={o.value}>
        {o.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default RangeToggle;
